/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useMemo } from 'react';
import { BreakDaysType } from '@havenengineering/module-shared-owners-library/dist/enums/breakDaysType';
import { Button } from '../Button';
import styles from './Let2OwnBreakSummary.module.scss';
import MaxBreakList from './MaxBreakList';
import { Alert } from '../../v2/components/Alert';
import { getDisplayDaysType } from '../../utils/displayDaysType';
import { getDisplayPeakType } from '../../utils/displayPeakType';
export var MODE;
(function (MODE) {
    MODE[MODE["RENEWAL"] = 0] = "RENEWAL";
    MODE[MODE["PRESENTATIONAL"] = 1] = "PRESENTATIONAL";
    MODE[MODE["CALCULATOR"] = 2] = "CALCULATOR";
})(MODE || (MODE = {}));
export const Let2OwnBreaksSummary = ({ isLoading, let2OwnSummary, mode = MODE.PRESENTATIONAL, handleRenewalClick, showMaxBreakList = false, breaksNotSavedAlertEnabled = false, }) => {
    const breaksInvalid = useMemo(() => {
        return (!(let2OwnSummary === null || let2OwnSummary === void 0 ? void 0 : let2OwnSummary.summary) ||
            Object.values(let2OwnSummary.summary).some((peakType) => Object.values(peakType).some(({ isValid }) => !isValid)));
    }, [let2OwnSummary]);
    const showInfoIcons = useMemo(() => mode === MODE.CALCULATOR || mode === MODE.RENEWAL, [mode]);
    const cards = useMemo(() => {
        var _a;
        if (!(let2OwnSummary === null || let2OwnSummary === void 0 ? void 0 : let2OwnSummary.summary))
            return [];
        return (_a = Object.entries(let2OwnSummary.summary)) === null || _a === void 0 ? void 0 : _a.map(([peakType, item]) => (<L2oBreakSummaryCard key={peakType} peakType={peakType} summary={item} showIcon={showInfoIcons}/>));
    }, [let2OwnSummary, showInfoIcons]);
    return (<div className={styles.container}>
      {mode === MODE.RENEWAL && <h3 className={styles.title}>Breaks required</h3>}
      <div className={styles.cardContainer}>{cards}</div>
      {mode === MODE.RENEWAL && breaksNotSavedAlertEnabled && (<div className={styles.notSavedAlert}>
          <Alert severity='warning' title='Breaks are reserved for 2 hours, after which time they will be cleared.' text='Please complete your Let2offset renewal to confirm your chosen breaks.'/>
        </div>)}
      {mode === MODE.RENEWAL && handleRenewalClick && (<div className={styles.buttonContainer}>
          <Button type='button' data-testid='continue-button' className={styles.nextButton} includeChevron chevronPosition='right' disabled={breaksInvalid || isLoading} onClick={handleRenewalClick}>
            Continue with renewal
          </Button>
        </div>)}
      {showMaxBreakList && <MaxBreakList let2OwnSummary={let2OwnSummary}/>}
    </div>);
};
const L2oBreakSummaryCard = ({ peakType, summary, showIcon, }) => {
    const getIconBaseUrl = (filename) => `https://www.haven.com/assets/icons/${filename}`;
    const peakTypeIsValid = useMemo(() => {
        return summary.midweek.isValid && summary.weekend.isValid;
    }, [summary]);
    return (<div className={styles.card}>
      {showIcon && peakTypeIsValid && (<img alt='checkmark icon' className={styles.icon} src={getIconBaseUrl('check.svg')}/>)}
      <h4 className={styles.peakTypeHeader}>{getDisplayPeakType(peakType)}</h4>
      <div className={styles.breakCountContainer}>
        <span className={styles.separator}/>
        {[BreakDaysType.MIDWEEK, BreakDaysType.WEEKEND].map((breakType) => (<div key={breakType} className={styles.breakCount}>
            <span>
              {summary[breakType].current}/
              {summary[breakType].min}
            </span>{' '}
            <span>{getDisplayDaysType(breakType)}</span>
          </div>))}
      </div>
    </div>);
};
